import { IComponentOptions, IController, IWindowService } from 'angular';
import { Transition } from '@uirouter/angularjs';
import { OTHER_ERROR } from '../../constants/message-types';
import { IPaymentData } from '../../../../core/services/payment/payment.interfaces';
import './payment-process.component.scss';

export class PaymentProcessController implements IController {
  static $inject = [
    '$window'
  ];
  config: IPaymentData;
  $transition$: Transition;

  constructor( private $window: IWindowService ) {

  }

  $onInit() {
    const config = this.$transition$.params().config;
    try {
      this.config = JSON.parse(config);
    } catch ( err ) {
      this.$window.parent.postMessage({ type: OTHER_ERROR, error: err.message || 'Error' }, '*');
    }
  }
}

export const PaymentProcessComponent: IComponentOptions = {
  controller: PaymentProcessController,
  template: require('./payment-process.component.html'),
  bindings: {
    $transition$: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states_mobile/payment-process/components/payment-process/payment-process.component.ts